import { render, staticRenderFns } from "./ProfileDamBody.vue?vue&type=template&id=4a0fa18d&"
import script from "./ProfileDamBody.vue?vue&type=script&lang=js&"
export * from "./ProfileDamBody.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDamBody.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports